module.exports = __webpack_public_path__ + "static/img/prague.19d5661.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/prague.jpg
// module id = MvjE
// module chunks = 1